<template>
    <div class="clearfix npagePage product">
        <div class="pde">
            <div class="carousel-inner">
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_01.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_02.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_03.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_04.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_05.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_06.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_07.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_08.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_09.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_10.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_11.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_12.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/lyusb_13.jpg" />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() { return {} }

}
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// ac3.vue?16ea0b5e